import React from 'react'
import Modal from 'components/Luxkit/Modal/Modal'
import Group from 'components/utils/Group'
import BookingProtectionComparison from './BookingProtectionComparison/BookingProtectionComparison'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  cancellationType: 'free' | 'flexible' | undefined;
  cancelUntilFullRefundDate: moment.Moment | undefined;
  cancelAfterNonRefundableDate?: moment.Moment | undefined;
}

function BookingProtectionModal(props: Props) {
  const { cancellationType, cancelUntilFullRefundDate, cancelAfterNonRefundableDate } = props

  return <Modal
    title="Cancellation Protection policy"
    size="large"
  >
    <Group direction="vertical" gap={20}>
      <BodyText variant="medium">
        Things don't always work out, so enjoy peace of mind knowing that the following cancellation options are available to you.
      </BodyText>
      <BookingProtectionComparison cancellationType={cancellationType} cancelUntilFullRefundDate={cancelUntilFullRefundDate} cancelAfterNonRefundableDate={cancelAfterNonRefundableDate} />
    </Group>
  </Modal>
}

export default BookingProtectionModal
